import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "common/locales";
import {
  setQuickAssessmentStarted,
  useAppDispatch,
  useAppSelector,
  User,
} from "model";

import { selectQuickAssessmentResultsById } from "model/quickAssessmentSlice";
import { useSelector } from "react-redux";
import StepCard from "./FirstStepCard";
import { NO_PROGRAMM_ID } from "./Programmes";
import { ProgrammeNameAndText } from "./ProgrammesDetailsDrawer";

export default function NoProgrammeDrawerElement() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.details);
  const quickAssessmentStarted = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
    (state) => (state as any).quickAssessmentStarted
  );

  const quickAssessmentResults = useAppSelector((state) =>
    selectQuickAssessmentResultsById(state, NO_PROGRAMM_ID)
  );
  const hasFilledOutQuickAssessment = !(
    Object.keys(quickAssessmentResults?.results ?? {}).length === 0
  );
  const maxHeight = "auto";
  if (isMobile && quickAssessmentStarted.quickAssessmentStarted && user) {
    return <>{isMobile && QuickAssessmentIframe(user)}</>;
  } else if (!hasFilledOutQuickAssessment) {
    return (
      <Box
        sx={{
          backgroundColor: "white",
          p: 3,
          gap: 5,
          flex: 1, // Take remaining space
          flexDirection: "column",
          display: "flex",
          alignItems: "top",
          justifyContent: "top",
          minHeight: "calc(100vh)", // Ensure minimum height even when loading
        }}
      >
        {ProgrammeNameAndText(
          {
            programmeName: "",
            guid: "",
            description: "",
            selectedActions: {},
            questionnaireUrl: "",
            welcomeText: "",
          },
          false,
          maxHeight,
          () => {
            //do nothing
          },
          "",
          t("no.programmes.available.body"),
          t,
          false
        )}

        {!quickAssessmentStarted.quickAssessmentStarted &&
          !hasFilledOutQuickAssessment && (
            <StepCard
              stepNumber={1}
              stepTitle="Do a quick assessment"
              stepDescription="The first step is to tell us a bit about your farm."
              buttonText="TELL US ABOUT YOUR FARM"
              daysLeft={122}
              status="In progress"
              onButtonClick={() => {
                dispatch(setQuickAssessmentStarted(true));
              }}
            />
          )}
      </Box>
    );
  } else {
    return ProgrammeNameAndText(
      {
        programmeName: "",
        guid: "",
        description: "",
        selectedActions: {},
        questionnaireUrl: "",
        welcomeText: "",
      },
      false,
      maxHeight,
      () => {
        //do nothing
      },
      "",
      t("quick.assessment.thank.you"),
      t,
      false
    );
  }
}
export const QuickAssessmentIframe = (user: User) => {
  return (
    <div
      style={{
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        height: "100vh",
        width: "100%",
        position: "absolute",
      }}
    >
      <iframe
        id="JotFormIFrame-252572906128359"
        title="New Customer Registration Form"
        allow="geolocation; microphone; camera; fullscreen; payment"
        src={`https://form.jotform.com/251602311826044?email=${
          user?.mail ?? ""
        }&guid=${user?.guid ?? ""}`}
        style={{
          top: 0,
          left: 0,
          margin: 0,
          padding: 0,
          height: "90%",
          width: "100%",
          position: "absolute",
        }}
      ></iframe>
      <script src="https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js"></script>
      <script>
        window.jotformEmbedHandler("iframe[id='JotFormIFrame-252572906128359']",
        "https://form.jotform.com/")
      </script>
    </div>
  );
};
